document.addEventListener('DOMContentLoaded', () => {
    const cartContainer = document.querySelector('#cart-drawer-container');

    if (!cartContainer) return;

    const updateAddons = () => {
        const addons = cartContainer.querySelectorAll('.scd__addon');

        addons.forEach(addon => {
            const isOpen = addon.classList.contains('open');

            addon.inert = !isOpen;

            const addonName = addon.id.replace('scd-', '');
            const openButton = cartContainer.querySelector(
                `[data-open="${addonName}"]`
            );

            if (openButton) {
                openButton.setAttribute('aria-expanded', String(isOpen));
            }
        });
    };

    updateAddons();

    const observer = new MutationObserver(updateAddons);

    observer.observe(cartContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });
});


document.querySelectorAll('.sf__accordion-item').forEach((item) => {
  const content = item.querySelector('.sf__accordion-content');
  const button = item.querySelector('.sf__accordion-button');

  if (!content || !button) return;

  const updateAccessibility = () => {
    const isOpen = item.classList.contains('open');

    content.inert = !isOpen;
    button.setAttribute('aria-expanded', String(isOpen));
  };

  updateAccessibility();
  const observer = new MutationObserver(updateAccessibility);

  observer.observe(item, {
    attributes: true,
    attributeFilter: ['class']
  });
});


const observer = new MutationObserver(() => {
    document.querySelectorAll('a[data-product-id]').forEach((element) => {
        element.classList.add('tabindex');
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

(function () {
  const selector = '.sf__custom-select';

  function getElements(dropdown) {
    return {
      trigger: dropdown.querySelector('.select-selected'),
      menu: dropdown.querySelector('.select-items'),
      options: Array.from(
        dropdown.querySelectorAll('.select-items > div')
      )
    };
  }

  function isOpen(menu) {
    return !menu.classList.contains('select-hide');
  }

  function updateOptions(dropdown) {
    const { menu, options } = getElements(dropdown);

    if (!menu) return;

    const open = isOpen(menu);

    options.forEach(option => {
      option.tabIndex = open ? 0 : -1;
      option.classList.add('tabindex');
    });
  }

  function closeDropdown(dropdown) {
    const { trigger, menu } = getElements(dropdown);

    if (trigger && menu && isOpen(menu)) {
      trigger.click();
    }

    updateOptions(dropdown);
  }

  // Initialiseer de dropdowns
  function initDropdowns() {
    document.querySelectorAll(selector).forEach(dropdown => {
      if (dropdown.dataset.keyboardInit === 'true') return;

      const { trigger, menu, options } = getElements(dropdown);

      if (!trigger || !menu) return;

      dropdown.dataset.keyboardInit = 'true';

      // Focus op de buitenste dropdown
      dropdown.tabIndex = 0;
      dropdown.classList.add('tabindex');

      // Bestaande outline class
      trigger.classList.add('tabindex');

      // Maak opties toegankelijk
      options.forEach(option => {
        option.tabIndex = -1;
        option.classList.add('tabindex');
      });

      // Houd de opties synchroon met openen/sluiten
      const observer = new MutationObserver(() => {
        updateOptions(dropdown);
      });

      observer.observe(menu, {
        attributes: true,
        attributeFilter: ['class']
      });

      updateOptions(dropdown);
    });
  }

  // Open automatisch bij Tab-focus
  document.addEventListener('focusin', function (event) {
    const dropdown = event.target.closest(selector);

    if (!dropdown) return;

    const { trigger, menu } = getElements(dropdown);

    if (!trigger || !menu) return;

    if (
      event.target === dropdown &&
      menu.classList.contains('select-hide')
    ) {
      trigger.click();
    }

    updateOptions(dropdown);
  });

  // Sluit als focus de dropdown verlaat
  document.addEventListener('focusout', function (event) {
    const dropdown = event.target.closest(selector);

    if (!dropdown) return;

    requestAnimationFrame(() => {
      if (dropdown.contains(document.activeElement)) return;

      closeDropdown(dropdown);
    });
  });

  // Toetsenbordbediening
  document.addEventListener('keydown', function (event) {
    const dropdown = event.target.closest(selector);

    if (!dropdown) return;

    const { menu, options } = getElements(dropdown);

    if (!menu) return;

    // Selecteer taal met Enter of Spatie
    if (
      options.includes(event.target) &&
      (event.key === 'Enter' || event.key === ' ')
    ) {
      event.preventDefault();
      event.target.click();
    }

    // Sluit met Escape
    if (event.key === 'Escape' && isOpen(menu)) {
      event.preventDefault();
      closeDropdown(dropdown);
      dropdown.focus();
    }
  });

  // Start na laden van de pagina
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDropdowns);
  } else {
    initDropdowns();
  }
})();

function disableDuplicateSlideTabbing() {
  document.querySelectorAll(
    '.swiper-slide-duplicate'
  ).forEach((slide) => {
    slide.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]'
    ).forEach((element) => {
      element.setAttribute('tabindex', '-1');
    });
  });
}

document.addEventListener('DOMContentLoaded', disableDuplicateSlideTabbing);

function initCollectionSliderAccessibility() {
  const selector = '.collection-list__inner--overflow';

  function updateTabbing() {
    document.querySelectorAll(`${selector} .swiper-container`).forEach((slider) => {
      const containerRect = slider.getBoundingClientRect();

      slider.querySelectorAll('.swiper-slide').forEach((slide) => {
        const rect = slide.getBoundingClientRect();

        const isVisible =
          rect.width > 0 &&
          rect.height > 0 &&
          rect.left >= containerRect.left - 1 &&
          rect.right <= containerRect.right + 1;

        slide.querySelectorAll(
          'a, button, input, select, textarea, [tabindex]'
        ).forEach((element) => {
          if (!element.hasAttribute('data-original-tabindex')) {
            element.dataset.originalTabindex =
              element.getAttribute('tabindex') ?? 'none';
          }

          if (isVisible) {
            const original = element.dataset.originalTabindex;

            if (original === 'none') {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', original);
            }
          } else {
            element.setAttribute('tabindex', '-1');
          }
        });
      });
    });
  }

  const observer = new MutationObserver(updateTabbing);

  document.querySelectorAll(`${selector} .swiper-wrapper`).forEach((wrapper) => {
    observer.observe(wrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  });

  window.addEventListener('resize', updateTabbing);
  document.addEventListener('focusin', (event) => {
    if (event.target.closest(selector)) {
      updateTabbing();
    }
  });

  updateTabbing();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionSliderAccessibility);
} else {
  initCollectionSliderAccessibility();
}

document.querySelectorAll('.gc-vid2-frame').forEach(function(frame) {
  const video = frame.querySelector('video');
  const button = frame.querySelector('.gc-vid2-playpause');

  if (!video || !button) return;

  const isNL = window.location.pathname.indexOf('/nl') === 0;

  function updateButton() {
    const paused = video.paused;

    button.classList.toggle('is-paused', paused);

    button.setAttribute(
      'aria-label',
      isNL
        ? button.getAttribute(
            paused ? 'data-nl-label-play' : 'data-nl-label-pause'
          )
        : (paused ? 'Play video' : 'Pause video')
    );
  }

  button.addEventListener('click', function() {
    if (video.paused) {
      video.play().catch(function() {
        updateButton();
      });
    } else {
      video.pause();
    }
  });

  video.addEventListener('play', updateButton);
  video.addEventListener('pause', updateButton);

  updateButton();
});

document.addEventListener('DOMContentLoaded', function () {
  const selector = '.yotpo-reviews-tab-floating-tab';

  // Focuspunt achteraan de pagina
  const focusPoint = document.createElement('span');
  focusPoint.tabIndex = 0;
  focusPoint.setAttribute('aria-hidden', 'true');
  focusPoint.style.cssText =
    'position:absolute;width:1px;height:1px;overflow:hidden;opacity:0;';

  document.body.appendChild(focusPoint);

  function makeYotpoAccessible() {
    document.querySelectorAll(selector).forEach(function(tab) {
      if (tab.dataset.a11yFixed === 'true') return;

      tab.dataset.a11yFixed = 'true';
      tab.setAttribute('tabindex', '-1');
      tab.setAttribute('role', 'button');
      tab.setAttribute('aria-label', 'Open reviews');

      tab.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          tab.click();
        }
      });
    });
  }

  // Vanaf het focuspunt naar de Reviews-knop
  focusPoint.addEventListener('focus', function() {
    const tab = document.querySelector(selector);

    if (tab) {
      tab.focus();
    }
  });

  makeYotpoAccessible();

  const observer = new MutationObserver(makeYotpoAccessible);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener('DOMContentLoaded', function () {
  function updateTabindex() {
    document.querySelectorAll('.sk-ing__tab').forEach(function(tab) {
      tab.setAttribute('tabindex', '0');
    });

    document.querySelectorAll('.sk-ing__panel.is-entering').forEach(function(panel) {
      panel.setAttribute('tabindex', '-1');
    });
  }

  updateTabindex();

  const observer = new MutationObserver(updateTabindex);

  document.querySelectorAll('.sk-ing__tabs, .sk-ing__panel').forEach(function(el) {
    observer.observe(el, {
      attributes: true,
      attributeFilter: ['class', 'tabindex', 'aria-selected']
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mq-wrap').forEach(function(wrap) {
    const track = wrap.querySelector('.mq-track');
    if (!track || wrap.dataset.toggleInitialized) return;

    wrap.dataset.toggleInitialized = 'true';

    // Button aanmaken
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mq-toggle';
    button.setAttribute('aria-controls', track.id || '');

    // Uniek ID voor de slider
    if (!track.id) {
      track.id = 'mq-track-' + Math.random().toString(36).slice(2, 10);
      button.setAttribute('aria-controls', track.id);
    }

    // Button boven de slider plaatsen
    const toolbar = document.createElement('div');
    toolbar.className = 'mq-toolbar';

    Object.assign(toolbar.style, {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: '8px 16px',
      background: '#F5F0E8'
    });

    Object.assign(button.style, {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      padding: '6px 10px',
      background: 'transparent',
      color: '#0a0a0a',
      border: '1px solid #0a0a0a',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      cursor: 'pointer',
      lineHeight: '1.4'
    });

    // Zichtbare focusindicator voor toetsenbordgebruikers
    const style = document.createElement('style');
    style.textContent = `
      .mq-toggle:focus-visible {
        box-shadow: 0 0 7px 3px rgba(72, 171, 224, 0.4) !important;
      }
    `;
    document.head.appendChild(style);

    function updateButton() {
      const isNL = window.location.pathname === '/nl' ||
                  window.location.pathname.startsWith('/nl/');

      const buttonText = isNL
        ? (paused ? 'Slider hervatten' : 'Slider pauzeren')
        : (paused ? 'Resume slider' : 'Pause slider');

      button.textContent = buttonText;
      button.setAttribute('aria-label', buttonText);
      button.setAttribute('aria-pressed', String(paused));
    }

    let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setPaused(value) {
      paused = value;

      track.style.setProperty(
        'animation-play-state',
        paused ? 'paused' : 'running',
        'important'
      );

      updateButton();
    }

    button.addEventListener('click', function () {
      setPaused(!paused);
    });

    // Toolbar buiten en boven de slider plaatsen
    toolbar.appendChild(button);
    wrap.before(toolbar);

    // Ruimte tussen de knop en de slider
    toolbar.style.marginBottom = '12px';
    toolbar.style.padding = '0 16px';
    toolbar.style.background = 'transparent';

    // Beginstatus instellen
    setPaused(paused);
  });
});

document.querySelectorAll('.sk-mq-toolbar').forEach(function(toolbar) {
  const parent = toolbar.parentElement;

  if (parent) {
    parent.style.setProperty('background', '#ffffff', 'important');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sk-mq-wrap').forEach(function(wrap, index) {
    const track = wrap.querySelector('.sk-mq-track');

    if (!track || wrap.dataset.toggleInitialized === 'true') return;

    wrap.dataset.toggleInitialized = 'true';

    const isNL = window.location.pathname === '/nl' ||
                 window.location.pathname.startsWith('/nl/');

    // Uniek ID voor de slider
    if (!track.id) {
      track.id = 'sk-mq-track-' + index;
    }

    // Toolbar boven en buiten de slider
    const toolbar = document.createElement('div');
    toolbar.className = 'sk-mq-toolbar';

    // Toegankelijke button
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'sk-mq-toggle';
    button.setAttribute('aria-controls', track.id);

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    let paused = reducedMotion.matches;

    function updateButton() {
      button.textContent = isNL
        ? (paused ? 'Slider hervatten' : 'Slider pauzeren')
        : (paused ? 'Resume slider' : 'Pause slider');

      button.setAttribute('aria-pressed', String(paused));
    }

    function setPaused(value) {
      paused = value;

      track.style.setProperty(
        'animation-play-state',
        paused ? 'paused' : 'running',
        'important'
      );

      updateButton();
    }

    button.addEventListener('click', function () {
      setPaused(!paused);
    });

    toolbar.appendChild(button);

    wrap.parentNode.insertBefore(toolbar, wrap);

    // Achtergrond parent-div overschrijven
    toolbar.parentElement.style.setProperty(
      'background',
      '#ffffff',
      'important'
    );

    // Beginstatus instellen
    setPaused(paused);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bc-hero-video').forEach(function(video) {
    const card = video.closest('.bc-hero-card');
    if (!card || card.querySelector('.bc-video-toggle')) return;

    const isNL = window.location.pathname === '/nl' ||
                 window.location.pathname.startsWith('/nl/');

    card.style.position = 'relative';

    // Bijhouden of de gebruiker handmatig heeft gepauzeerd
    let manuallyPaused = false;

    // Maak toegankelijke knop aan
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bc-video-toggle';

    button.innerHTML = `
      <svg class="bc-icon-play"
           width="18" height="18"
           viewBox="0 0 24 24"
           aria-hidden="true">
        <path d="M7 4.5L20 12L7 19.5Z"
              fill="currentColor"/>
      </svg>

      <svg class="bc-icon-pause"
           width="18" height="18"
           viewBox="0 0 24 24"
           aria-hidden="true">
        <rect x="5" y="4" width="5" height="16"
              fill="currentColor"/>
        <rect x="14" y="4" width="5" height="16"
              fill="currentColor"/>
      </svg>
    `;

    // Update de knop op basis van de videostatus
    function updateButton() {
      const paused = manuallyPaused || video.paused;

      button.classList.toggle('is-paused', paused);

      button.setAttribute(
        'aria-label',
        isNL
          ? (paused ? 'Video afspelen' : 'Video pauzeren')
          : (paused ? 'Play video' : 'Pause video')
      );
    }

    // Voorkom dat de carousel klik-events overneemt
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function(type) {
      button.addEventListener(type, function(event) {
        event.stopPropagation();
      });
    });

    // Play/pauze functionaliteit
    button.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (manuallyPaused || video.paused) {
        // Video hervatten
        manuallyPaused = false;

        video.play().catch(function(error) {
          console.error('Video play error:', error);
          updateButton();
        });
      } else {
        // Video pauzeren
        manuallyPaused = true;
        video.pause();
      }

      updateButton();
    });

    // Voorkom dat carousel video opnieuw start
    video.addEventListener('play', function() {
      if (manuallyPaused) {
        video.pause();
      }

      updateButton();
    });

    video.addEventListener('pause', updateButton);

    // Knop plaatsen
    card.appendChild(button);

    // Beginstatus
    updateButton();
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const stage = document.querySelector('.bc-hero-stage');
  const dots = document.querySelectorAll('.bc-hero-dots .bc-hero-dotbtn');

  if (!stage) return;

  const cards = Array.from(stage.querySelectorAll('.bc-hero-card'));

  if (cards.length !== 3) return;

  let savedPositions = cards.map(card => card.dataset.pos);
  let manualInteraction = false;
  let restoring = false;
  let manualTimer;

  function savePositions() {
    savedPositions = cards.map(card => card.dataset.pos);
    updateDots();
  }

  function updateDots() {
    const activeIndex = cards.findIndex(card => card.dataset.pos === 'front');

    dots.forEach(function(dot, index) {
      dot.setAttribute('aria-current', String(index === activeIndex));
    });
  }

  function allowManualInteraction() {
    manualInteraction = true;

    clearTimeout(manualTimer);

    manualTimer = setTimeout(function () {
      savePositions();
      manualInteraction = false;
    }, 800);
  }

  // Handmatige kaartinteractie
  stage.addEventListener('pointerdown', allowManualInteraction, true);

  stage.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      allowManualInteraction();
    }
  }, true);

  // Dots als handmatige navigatie herkennen
  dots.forEach(function(dot) {
    dot.addEventListener('click', allowManualInteraction, true);

    dot.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        allowManualInteraction();
      }
    }, true);
  });

  const observer = new MutationObserver(function () {
    if (restoring) return;

    if (manualInteraction) {
      savePositions();
      return;
    }

    const changed = cards.some(function(card, index) {
      return card.dataset.pos !== savedPositions[index];
    });

    if (changed) {
      restoring = true;

      cards.forEach(function(card, index) {
        card.dataset.pos = savedPositions[index];
      });

      updateDots();

      requestAnimationFrame(function () {
        restoring = false;
      });
    }
  });

  observer.observe(stage, {
    subtree: true,
    attributes: true,
    attributeFilter: ['data-pos']
  });

  updateDots();
});

document.addEventListener('DOMContentLoaded', function () {
  const tablist = document.querySelector('.bc-origin__tabs');
  if (!tablist) return;

  const tabs = Array.from(tablist.querySelectorAll('.bc-origin__tab'));
  const panels = tabs.map(tab =>
    document.getElementById(tab.getAttribute('aria-controls'))
  );

  function activateTab(index, moveFocus = false) {
    tabs.forEach(function(tab, i) {
      const active = i === index;

      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('tabindex', '0');

      if (panels[i]) {
        panels[i].hidden = !active;
        panels[i].setAttribute('tabindex', '-1');
      }
    });

    if (moveFocus) {
      tabs[index].focus();
    }
  }

  tabs.forEach(function(tab, index) {
    tab.addEventListener('click', function() {
      activateTab(index);
    });

    tab.addEventListener('keydown', function(event) {
      let nextIndex;

      switch (event.key) {
        case 'ArrowRight':
          nextIndex = (index + 1) % tabs.length;
          break;
        case 'ArrowLeft':
          nextIndex = (index - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      activateTab(nextIndex, true);
    });
  });

  // Beginstatus op basis van aria-selected
  const initialIndex = tabs.findIndex(
    tab => tab.getAttribute('aria-selected') === 'true'
  );

  activateTab(initialIndex >= 0 ? initialIndex : 0);
});

